
import React from "react";
import { i18nManager } from "../../i18n";
import styles from "../../assets/style.module.css";
import { i18nManager as globalI18nManager } from "../../../../../i18n";
import { ITeamHistory, Status } from "../../../../../services";

export interface TeamTileProps {
    team: ITeamHistory;
}

function TeamTile({ team: t }: TeamTileProps) {

    const labels = i18nManager.Labels.team_history;
    const apps = t.extra_data?.appearance_count ?? 0;
    const won = t.extra_data?.appearance_won ?? 0;
    const background = t.team_extra_data?.banner_url ?? t.logo_url;
    const country = t.country_code ? globalI18nManager.queryCountryCurrency(t.country_code, "country_code", "country_name") : null;
    const achievements: string[] = t.team_extra_data?.recent_achievements ?? [];

    return (<a className={styles["tile"]} target="_blank" rel="noreferrer" href={`${window.location.origin}/te/${t.public_id}`}>
        {background && (<img className={styles["tile-bg"]} src={background} alt="" aria-hidden />)}
        {t.logo_url && (<img className={styles["tile-logo"]} src={t.logo_url} alt={t.name} />)}
        <div className={styles["tile-by"]}>{t.status === Status.ACTIVE ? labels.current : labels.with}</div>
        <div className={styles["tile-name"]}>{t.name}</div>
        <div className={styles["tile-period"]}>
            {new Date(t.join_date).getFullYear()} – {t.exit_date ? new Date(t.exit_date).getFullYear() : labels.present}{country ? ` · ${country}` : ""}
        </div>
        <div className={styles["tile-stats"]}>
            <div>
                <div className={styles["stat-val"]}>{apps}</div>
                <div className={styles["stat-lbl"]}>{labels.apps}</div>
            </div>
            <div>
                <div className={styles["stat-val"]}>{won}</div>
                <div className={styles["stat-lbl"]}>{labels.won}</div>
            </div>
        </div>
        {achievements.length > 0 && (<div className={styles["tile-achs"]}>
            {achievements.map((a) => <span key={a} className={styles["chip"]}>{a}</span>)}
        </div>)}
    </a>);
}

export default TeamTile;
